import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import Home from "./components/Home";
import IntroductionForm from './pages/introductionForm'
import FormInvite from './pages/forminvite'
import Channel from './pages/channel'
import InboxPage from './components/Inbox'
import Schedule from './pages/schedule'
import PendingPosts from './pages/pendingPosts'
import InviteAccept from './pages/inviteAccept';
import OrgNameChange from './pages/orgdetail';
import AlertList from './pages/alertList';
import Account from './pages/account';
import Insights from './pages/insights';
import CampaignManagement from './pages/campaigns';
import Subscriptions from './pages/subscriptions';
import Payment from './pages/payment';
import MyAccount from './pages/myAccount';
import Pricing from './pages/Pricing';

const AppRoutes = [
    {
        index: true,
        element: <Home />,
        requireAuth: true,
    },
    {
        path: '/counter',
        element: <Counter />
    },
    {
        path: '/fetch-data',
        requireAuth: true,
        element: <FetchData />
    },
    {
        path: '/introduction',
        requireAuth: true,
        element: <IntroductionForm />
    },
    {
        path: '/forminvite',
        element: <FormInvite />,
        requireAuth: true
    },
    {
        path: '/showinvite',
        element: <InviteAccept />,
        requireAuth: true
    },
    {
        path: '/pchannels',
        element: <Channel />,
        requireAuth: true
    },
    {
        path: '/inbox',
        element: <InboxPage />,
        requireAuth: true
    },
    {
        path: '/schedule',
        element: <Schedule />,
        requireAuth: true
    },
    {
        path: '/pendingposts/:postId?',
        element: <PendingPosts />,
        requireAuth: true
    },
    {
        path: '/orgdetail',
        element: <OrgNameChange />,
        requireAuth: true
    },
    {
        path: '/alertlist',
        element: <AlertList />,
        requireAuth: true
    },
    {
        path: '/pinsights',
        element: <Insights />,
        requireAuth: true
    },
    {
        path: '/account',
        element: <Account />,
        requireAuth: true
    },
    {
        path: '/managecampaigns',
        element: <CampaignManagement />,
        requireAuth: true
    },
    {
        path: '/subscriptions',
        element: <Subscriptions />,
        requireAuth: false
    },
    {
        path: '/pricing',
        element: <Pricing />,
        requireAuth: true
    },
    {
        path: '/payment',
        element: <Payment />,
        requireAuth: true
    },
    {
        path: '/myaccount',
        element: <MyAccount />,
        requireAuth: true
    },
    ...ApiAuthorzationRoutes
];

export default AppRoutes;
